// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1_XG2","cls2":"ResearchInterestTags-cls2_sSJ ResearchInterestTags-cls1_XG2"};